<template>
  <div class="vs-app-layout">
    <!-- <header class="vs-app-header "> -->
    <header class="vs-app-header fx__header">
      <appHeader />
    </header>
    <div class="vs-app-sub-layout">
      <sideBar />
      <div class="vs-app-content" :style="{ 'padding-left': $store.state.core.menuWidth }">
        <!-- 路由标签页联动 html -->
        <!-- <div class="fx-tag fx__bgcolor fx__item" :class="{ wf__title: selectedName == item.name }" v-for="(item, index) in count" :key="index">
          <span style="" class="fx-tag-span" @click="selected(item)">{{ item.text }}</span>
          <i class="fa fa-close" @click="handleClose(item)"></i>
        </div> -->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import sideBar from "./sideBar"
import appHeader from "./header"

export default {
  data() {
    return {
      count: [],
      selectedName: "",
    }
  },
  components: { sideBar, appHeader },
  // <!-- 路由标签页联动 js -->
  // watch: {
  //   $route(to, from) {
  //     let _this = this;
  //     if (!to.name) { //对于路由没有配置 name 属性的不创建标签页
  //       _this.selectedName = "";
  //       return;
  //     }else{
  //     if(to.name == 'core-modulesNav'){
  //       _this.selectedName = to.name+`${to.params.index}`
  //     }else{
  //       _this.selectedName = to.name;
  //       }
  //     if (_this.count.some((p) => p.name == _this.selectedName)) return; //如果便签页数组存在路由便签则不再加入便签页
  //     _this.count.push({ name: _this.selectedName, path: _this.$route.path, text: this.$app.menusDict[to.name] ? this.$app.menusDict[to.name].text : to.meta.title || _this.selectedName });
  //     localStorage.setItem("count", JSON.stringify(_this.count));
  //     }
  //   },
  // },
  // mounted() {
  //   let _this = this;
  //   _this.count = JSON.parse(localStorage.getItem("count")) || [];
  //   _this.selectedName = _this.$route.name;
  //   if (_this.count.length < 1) {
  //     _this.count.push({ name: _this.$route.name, path: _this.$route.path, text: this.$app.menusDict[_this.$route.name] ? this.$app.menusDict[_this.$route.name].text : _this.$route.meta.title || _this.$route.name });
  //     localStorage.setItem("count", JSON.stringify(_this.count));
  //   }
  // },
  // methods: {
  //   selected(item) {
  //     let _this = this;
  //     _this.$router.push(item.path);
  //   },
  //   //删除标签页
  //   handleClose(item) {
  //     let _this = this;
  //     if (_this.count.length <= 1) return;
  //     const index = _this.count.findIndex((p) => p.name == item.name);
  //     this.count.splice(index, 1);
  //     localStorage.setItem("count", JSON.stringify(_this.count));
  //     if (item.name == _this.$route.name) { //删除的标签页是当前页面时 跳到数组最后的标签页去
  //       let i = _this.count.length - 1;
  //       if (i <= 0) i = 0;
  //       _this.$router.push(_this.count[i].path);
  //     }
  //   },
  // },
}
</script>

<style lang="scss" scoped>
/* body {
  overflow: hidden;
} */
// <!-- 路由标签页联动  scss-->
// .fx-tag {
//   &:first-child {
//     margin-left: 4px;
//   }
//   display: inline-block;
//   cursor: pointer;
//   height: 25px;
//   line-height: 25px;
//   margin: 4px 4px 2px 0;
//   padding: 0 8px;
//   border-radius: 3px;
//   font-size: 12px;
//   vertical-align: middle;
//   opacity: 1;
//   overflow: hidden;
//   .fx-tag-span {
//     margin-right: 5px;
//     padding: 5px;
//     font-size: 14px;
//   }
// }
.vs-app-layout {
  overflow: hidden;
  display: flex;
  flex-direction: column;

  height: calc(100vh);

  .vs-app-header {
    /* height: 50px; */
    flex: 70px 0 0;
    // z-index: 99;
  }

  .vs-app-sub-layout {
    flex: 1;
    height: calc(100% - 70px);
    display: flex;
  }

  .vs-app-sider {
    flex-shrink: 0;
    overflow: auto;
  }

  .vs-app-content {
    transition: all 0.3s ease;
    overflow: hidden;
    flex-grow: 1;
    padding-left: 260px;
    z-index: 98;
    position: relative;
  }
}
</style>
